/* Timeline is reusable without a chapter navigation or a page-specific controller. */
if (!customElements.get('park-steps-timeline')) customElements.define('park-steps-timeline', class extends HTMLElement {
  connectedCallback() {
    if(this.abort)return;
    this.abort=new AbortController();const options={signal:this.abort.signal,passive:true};
    this.track=this.querySelector('.park-about__items');this.root=this.querySelector('.park-about');this.items=[...this.querySelectorAll('[data-timeline-item]')];
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.mobile=matchMedia('(max-width:760px)');
    this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};
    [window,this.track].filter(Boolean).forEach(target=>target.addEventListener('scroll',this.schedule,options));
    window.addEventListener('resize',this.schedule,options);window.addEventListener('pageshow',this.schedule,options);
    this.addEventListener('focusin',this.schedule,options);
    this.motion.addEventListener('change',this.schedule,options);
    this.addEventListener('shopify:block:select',event=>{event.target.closest('[data-timeline-item]')?.setAttribute('data-timeline-selected','');this.schedule()},options);
    this.addEventListener('shopify:block:deselect',event=>{event.target.closest('[data-timeline-item]')?.removeAttribute('data-timeline-selected');this.schedule()},options);
    this.schedule();
  }
  update(){
    if(!this.track||!this.root)return;
    const clamp=v=>Math.max(0,Math.min(1,v));const bounds=this.track.getBoundingClientRect();const reveal=this.dataset.reveal==='true'&&!this.motion.matches;
    this.root.style.setProperty('--om-progress',reveal?clamp((innerHeight*.7-bounds.top-20)/Math.max(1,bounds.height-40)):1);
    this.items.forEach((item,index)=>{
      const box=item.getBoundingClientRect();let opacity=1;
      if(reveal&&!item.contains(document.activeElement)&&!item.hasAttribute('data-timeline-selected')){
        if(this.mobile.matches){const atEnd=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;opacity=atEnd&&index===this.items.length-1?1:.3+.7*(1-clamp(Math.abs(box.left-bounds.left)/(box.width+16)))}
        else opacity=.15+.85*clamp((innerHeight-box.top)/(innerHeight/3));
      }
      item.style.setProperty('--om-reveal',opacity.toFixed(4));
    });
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;cancelAnimationFrame(this.frame);this.frame=0;this.root?.style.removeProperty('--om-progress');this.items?.forEach(item=>item.style.removeProperty('--om-reveal'))}
});
